"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SectionSubheading = exports.SectionHeader = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
require("../../foundations/color-palette");
require("../../foundations/fonts");
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _excluded = ["className", "h1", "h2", "h3", "h4", "h5", "h6", "hsub", "sectionheader", "gray", "pink", "teal", "darkTeal", "darkYellow", "darkOrange", "darkerTeal", "darkestTeal", "darkGrey", "white", "cream"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var baseHeading = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 700;\n  font-family: var(--bf-lead-font);\n  color: var(--main-color);\n\n  /* colors */\n  &.gray {\n    --main-color: var(--bf-core-gray);\n  }\n  \n  &.pink {\n    --main-color: var(--bf-core-pink);\n  }\n\n  &.teal {\n    --main-color: var(--bf-core-teal);\n  }\n\n  &.darkTeal {\n    --main-color: var(--bf-core-dark-teal);\n  }\n\n  &.darkYellow {\n    --main-color: var(--bf-dark-yellow);\n  }\n\n  &.darkOrange {\n    --main-color: var(--bf-dark-orange);\n  }\n\n  &.darkerTeal {\n    --main-color: var(--bf-darker-teal);\n  }\n\n  &.darkestTeal {\n    --main-color: var(--bf-darkest-teal);\n  }\n\n  &.darkGrey {\n    --main-color: var(--bf-dark-grey);\n  }\n  \n  &.cream {\n    --main-color: var(--main-color);\n  }\n\n  &.white {\n    --main-color: var(--bf-core-white);\n  }\n"])));
var Heading0 = (0, _styledComponents.default)(baseHeading)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 40px;  \n  line-height: 45px;\n\n  @media (min-width: ", ") {\n    font-size: 50px;\n    line-height: 55px;\n  }\n\n  @media (min-width: ", ") {\n    /* margin-bottom: 40px; */\n    font-size: 55px;  \n    line-height: 60px;\n  }\n"])), _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
var Heading1 = (0, _styledComponents.default)(baseHeading)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 30px;\n  line-height: 35px;\n  margin-bottom: 25px;\n  \n  @media (min-width: ", ") {\n    font-size: 40px;  \n    line-height: 45px;\n  }\n\n  @media (min-width: ", ") {\n    /* margin-bottom: 40px; */\n    font-size: 50px;\n    line-height: 55px;\n  }\n"])), _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
exports.SectionHeader = Heading1;
var Heading2 = (0, _styledComponents.default)(baseHeading)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 25px;  \n  line-height: 30px;\n  font-weight: ", ";\n  margin-bottom: 15px;\n\n  @media (min-width: ", ") {\n    font-size: 32.5px;  \n    line-height: 37.5px;\n\n  }\n\n  @media (min-width: ", ") {\n    /* margin-bottom: 40px; */\n    font-size: 40px;  \n    line-height: 45px;\n    /* margin-bottom: 20px; */\n  }\n"])), function (props) {
  return props.special ? 500 : 700;
}, _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
var Heading3 = (0, _styledComponents.default)(baseHeading)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 20px;  \n  line-height: 25px;\n  font-weight: ", ";\n  margin-bottom: 20px;\n\n  @media (min-width: ", ") {\n    font-size: 24px;  \n    line-height: 29px;\n  }\n\n  @media (min-width: ", ") {\n    /* margin-bottom: 40px; */\n    font-size: 30px;  \n    line-height: 35px;\n  }\n"])), function (props) {
  return props.special ? 500 : 600;
}, _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
var Heading4 = (0, _styledComponents.default)(baseHeading)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 24px;  \n  line-height: 29px;\n  font-weight: ", ";\n"])), function (props) {
  return props.special ? 400 : 600;
});
var Heading5 = (0, _styledComponents.default)(baseHeading)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 20px;  \n  line-height: 25px;\n"])));
var Heading6 = (0, _styledComponents.default)(baseHeading)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 12.8px;\n  line-height: 18.8px;\n  font-weight: ", " !important;\n\n  @media (min-width: ", ") {\n    font-size: 16px;\n    line-height: 22.856px;\n  }\n  \n\n  @media (min-width: ", ") {\n    font-size: 18px;  \n    line-height: 23px;\n  }\n"])), function (props) {
  return props.special ? 400 : 500;
}, _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.s);
var SectionSubheading = (0, _styledComponents.default)(baseHeading)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 16px;  \n  line-height: 22.856px;\n  font-weight: ", " !important;\n  margin-bottom: 15px;\n\n  @media (min-width: ", ") {\n    font-size: 18px;  \n    line-height: 28px;\n  }\n\n  @media (min-width: ", ") {\n    /* margin-bottom: 40px; */\n    font-size: 20px;  \n    line-height: 30px;\n  }\n"])), function (props) {
  return props.special ? 500 : 600;
}, _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
exports.SectionSubheading = SectionSubheading;
var Heading = function Heading(_ref) {
  var className = _ref.className,
    h1 = _ref.h1,
    h2 = _ref.h2,
    h3 = _ref.h3,
    h4 = _ref.h4,
    h5 = _ref.h5,
    h6 = _ref.h6,
    hsub = _ref.hsub,
    sectionheader = _ref.sectionheader,
    gray = _ref.gray,
    pink = _ref.pink,
    teal = _ref.teal,
    darkTeal = _ref.darkTeal,
    darkYellow = _ref.darkYellow,
    darkOrange = _ref.darkOrange,
    darkerTeal = _ref.darkerTeal,
    darkestTeal = _ref.darkestTeal,
    darkGrey = _ref.darkGrey,
    white = _ref.white,
    cream = _ref.cream,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var colorClassName = Object.entries({
    gray: gray,
    pink: pink,
    teal: teal,
    darkTeal: darkTeal,
    darkYellow: darkYellow,
    darkOrange: darkOrange,
    darkerTeal: darkerTeal,
    darkestTeal: darkestTeal,
    darkGrey: darkGrey,
    white: white
  }).find(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      select = _ref3[1];
    return select;
  });
  var calculatedClassNames = colorClassName ? "".concat(className, " ").concat(colorClassName[0]) : "".concat(className);
  if (hsub) return _react.default.createElement(SectionSubheading, Object.assign({
    className: "".concat(calculatedClassNames, " bf-semibold ").concat(className)
  }, props));
  if (h6) return _react.default.createElement(Heading6, Object.assign({
    className: calculatedClassNames
  }, props));
  if (h5) return _react.default.createElement(Heading5, Object.assign({
    className: calculatedClassNames
  }, props));
  if (h4) return _react.default.createElement(Heading4, Object.assign({
    className: calculatedClassNames
  }, props));
  if (h3) return _react.default.createElement(Heading3, Object.assign({
    className: calculatedClassNames
  }, props));
  if (h2) return _react.default.createElement(Heading2, Object.assign({
    className: calculatedClassNames
  }, props));
  if (h1 || sectionheader) return _react.default.createElement(Heading1, Object.assign({
    className: calculatedClassNames
  }, props));
  return _react.default.createElement(Heading0, Object.assign({
    className: calculatedClassNames
  }, props));
};
var _default = Heading;
exports.default = _default;